import React, { FC } from 'react';
import ModalDialog from '../components/modal/ModalDialog';
import './CheckBeforeAddingModal.scss';
import { Button, ButtonSize, ButtonTheme } from './Button';
import { useTranslation } from 'react-i18next';
import HorizontalRuler from './HorizontalRuler';
import { UnavailableProductOut } from '../../store/api';
import { ExpandableTable } from './TableRow';

export type RemoveUnavailableProductsModalProps = {
    readonly withdrawnProducts: UnavailableProductOut[];
    readonly comingSoonProducts: UnavailableProductOut[];
    readonly onProceed: () => void;
    readonly onCancel: () => void;
    readonly isLoading: boolean;
};

export const RemoveUnavailableProductsModal: FC<RemoveUnavailableProductsModalProps> = ({
    withdrawnProducts,
    comingSoonProducts,
    onProceed,
    onCancel,
    isLoading
}) => {
    const HEIGHT_SPACER = 5;
    const { t } = useTranslation();

    if (withdrawnProducts.length === 0 && comingSoonProducts.length === 0) {
        return null;
    }

    return (
        <ModalDialog
            show={true}
            title={t('notifications.unavailableProductsModal.remove.title')}
            titleClassName="title"
            wrapClassName="check-before-adding-modal"
            boldHeader={false}
        >
            <HorizontalRuler heightSpacer={HEIGHT_SPACER} />
            <div className="description">{t('notifications.unavailableProductsModal.remove.message')}</div>
            {withdrawnProducts.length > 0 ? (
                <>
                    <HorizontalRuler heightSpacer={HEIGHT_SPACER} />
                    <div className="subtitle">{t('notifications.unavailableProductsModal.remove.noLongerForSale')}</div>
                    <ExpandableTable products={withdrawnProducts} />
                    <br />
                </>
            ) : null}
            {comingSoonProducts.length > 0 ? (
                <>
                    <HorizontalRuler heightSpacer={HEIGHT_SPACER} />
                    <div className="subtitle">{t('notifications.unavailableProductsModal.remove.comingSoon')}</div>
                    <ExpandableTable products={comingSoonProducts} />
                </>
            ) : null}
            <div className="actions">
                <Button
                    onClick={onCancel}
                    text={t('cancel')}
                    theme={ButtonTheme.POSITIVE_INVERT}
                    size={ButtonSize.LARGE}
                    className="cancel-button"
                    disabled={isLoading}
                />
                <Button
                    onClick={onProceed}
                    text={t('notifications.unavailableProductsModal.remove.proceedButton')}
                    className="proceed-button"
                    size={ButtonSize.LARGE}
                    disabled={isLoading}
                    isLoading={isLoading}
                />
            </div>
        </ModalDialog>
    );
};
